export default [
"18 岁 ~ 23 岁",
"24 岁 ~ 29 岁",
"30 岁 ~ 35 岁",
"36 岁 ~ 41 岁",
"42 岁 ~ 47 岁",
"48 岁 ~ 53 岁",
"54 岁 ~ 59 岁",
"60 岁 ~ 65 岁"
]


// WEBPACK FOOTER //
// ./src/Data/ages.js